import { Trans } from 'react-i18next';

import { InvoiceImage } from '../../../../../../images';

export const InvoicePopover = () => (
  <div className="flex flex-col items-center bg-background-base-primary p-4 h-[350px] w-[400px] rounded-xl shadow-high">
    <span className="typography-paragraph-3 text-text-secondary">
      <Trans
        i18nKey="modal.addDevices.description.invoice"
        components={[<span key="span" className="typography-inline-highlight-3 text-text-primary" />]}
      />
    </span>
    <InvoiceImage />
  </div>
);
